<template>
    <v-expansion-panel>
        <v-expansion-panel-header
            style="background-color: #F2F2F2;"
            class="black--text subtitle-1 font-weight-medium" >
            <div class="tooltip-wrap">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            style="display: inline"
                            v-bind="attrs"
                            v-on="on"
                            class="list-tooltip">
                            {{ title }}
                            <v-icon small>mdi-help-rhombus</v-icon>
                        </div>
                    </template>
                    <span>{{ tooltipText('Portal - Income Planner - Retirement Age') }}</span>
                </v-tooltip>
            </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content color="white">
            <div v-if="individuals[0]">
                <p style="margin-top: 20px"><b>{{ individuals[0].name }}</b></p>
                <v-slider
                    v-if="individuals[0]"
                    v-model="individualOne.retirementAge"
                    :min="individuals[0].current_age"
                    :max="individuals[0].will_die_at"
                    :disabled="disabled"
                    thumb-label="always"
                    @end="$emit('retirementAgeUpdated', { individualIndex: 0, payload: { retirement_age: individualOne.retirementAge } })">
                    <template v-slot:prepend>
                        <span>Now</span>
                    </template>
                    <template v-slot:append>
                        <span>Life Expectancy</span>
                    </template>
                </v-slider>
            </div>
            <div v-if="individuals[1]">
                <p><b>{{ individuals[1].name }}</b></p>
                <v-slider
                    v-if="individuals[1]"
                    v-model="individualTwo.retirementAge"
                    :min="individuals[1].current_age"
                    :max="individuals[1].will_die_at"
                    :disabled="disabled"
                    thumb-label="always"
                    @end="$emit('retirementAgeUpdated', { individualIndex: 1, payload: { retirement_age: individualTwo.retirementAge } })">
                    <template v-slot:prepend>
                        <span>Now</span>
                    </template>
                    <template v-slot:append>
                        <span>Life Expectancy</span>
                    </template>
                </v-slider>
            </div>

        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>

export default {
    props: {
        individuals: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    inject: ['tooltipText'],

    data() {
        return {
            individualOne: {
                retirementAge: this.individuals[0] ? this.individuals[0].retirement_age : 67
            },
            individualTwo: {
                retirementAge: this.individuals[1] ? this.individuals[1].retirement_age : 67
            },
            title: 'Retirement Age'
        }
    }
}
</script>
